import React, { useEffect, useRef, useState } from 'react';

import { SquareImageWrapper, Image } from './wrappers';

interface ISquareImage {
  src: string;
  width: string;
  height: string;
  squarePixels: number;
  alt?: string;
}

let resizeTimeout: ReturnType<typeof setTimeout>;

const SquareImage = ({ src, width, height, squarePixels, alt }: ISquareImage) => {
  const imageRef = useRef<HTMLImageElement | null>(null);
  const [wrapperWidth, setWrapperWidth] = useState('');
  const [wrapperHeight, setWrapperHeight] = useState('');

  const calculateMeasurements = () => {
    if (imageRef.current) {
      const rects = imageRef.current.getBoundingClientRect();
      const imageWidth = rects.width;
      const imageHeight = rects.height;
      if (!!imageWidth && !!imageHeight) {
        const imageSquare = imageWidth * imageHeight;
        const downScaleValue = squarePixels / imageSquare;
        setWrapperWidth(Math.round(Math.sqrt(imageWidth * imageWidth * downScaleValue)) + 'px');
        setWrapperHeight(Math.round(Math.sqrt(imageHeight * imageHeight * downScaleValue)) + 'px');
      }
    }
  };

  const onWindowResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(calculateMeasurements, 250);
  };

  useEffect(() => {
    calculateMeasurements();
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', onWindowResize);
      imageRef.current?.addEventListener('load', calculateMeasurements);
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', onWindowResize);
        imageRef.current?.removeEventListener('load', calculateMeasurements);
      }
    };
  }, [imageRef]);

  return (
    <SquareImageWrapper style={{ width: wrapperWidth || width, height: wrapperHeight || height }}>
      <Image src={src} ref={imageRef} alt={alt} />
    </SquareImageWrapper>
  );
};

export default SquareImage;
